import React, {useState} from 'react';
import DropdownMenu from '../StockItems/DropdownMenu';

function onMouseDown(e){
  e.preventDefault();
}

function App(props) {

  var clickFontFamily = props.clickFontFamily;
  var currentFont = props.currentFont;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;

  if (!currentFont){
    currentFont = '';
  }  
  currentFont = currentFont.trim();
  if (currentFont.indexOf('"') === 0){
    currentFont = currentFont.substr(1, currentFont.length - 2);    
  }

  const [filterBit, setFilterBit] = useState('noFilter');
  const [searchText, setSearchText] = useState('');

  function compare(a, b) {
    if (a.n < b.n) {
      return -1;
    }
    if (a.n > b.n) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

  var fonts = [{n:'Verdana', t:'sans-serif'}, {n:'Helvetica', t:'sans-serif'}, {n:'Tahoma', t:'sans-serif'},{n:'Trebuchet MS', t:'sans-serif'},{n:'Georgia', t:'serif'},{n:'Garamond', t:'serif'},{n:'Courier New', t:'monospace'},{n:'Brush Script MT', t:'cursive'},{n:'Roboto', t:'sans-serif'},{n:'Open Sans', t:'sans-serif'},{n:'Lato', t:'sans-serif'},{n:'Oswald', t:'sans-serif'},{n:'Slabo 27px', t:'serif'},{n:'Roboto Condensed', t:'sans-serif'},{n:'Montserrat', t:'sans-serif'},{n:'Montserrat Alternates', t:'sans-serif'},{n:'Source Sans Pro', t:'sans-serif'},{n:'Raleway', t:'sans-serif'},{n:'PT Sans', t:'sans-serif'},{n:'Playfair Display', t:'serif'},{n:'Bitter', t:'serif'},{n:'Libre Baskerville', t:'serif'},{n:'Archivo Narrow', t:'sans-serif'},{n:'Alegreya Sans', t:'sans-serif'},{n:'Ubuntu', t:'sans-serif'},{n:'Heebo', t:'sans-serif'},{n:'Cabin', t:'sans-serif'},{n:'Lobster', t:'cursive'},{n:'Pacifico', t:'cursive'},{n:'Abril Fatface', t:'cursive'},{n:'Barlow', t:'sans-serif'},{n:'Bree Serif', t:'serif'},{n:'Bonbon', t:'cursive'},{n:'Ropa Sans', t:'sans-serif'},{n:'Amiri', t:'serif'},{n:'Orbitron', t:'sans-serif'},{n:'Zilla Slab', t:'serif'},{n:'Great Vibes', t:'cursive'},{n:'Cantata One', t:'serif'},{n:'Roboto Slab', t:'serif'},{n:'Cardo', t:'serif'},{n:'Poppins', t:'sans-serif'},{n:'Merriweather', t:'serif'},{n:'Lora', t:'serif'},{n:'Domine', t:'serif'},{n:'Karla', t:'sans-serif'},{n:'EB Garamond', t:'serif'},{n:'Neuton', t:'serif'},{n:'Josefin Slab', t:'serif'},{n:'Unna', t:'serif'},{n:'Abhaya Libre', t:'serif'},{n:'Rubik', t:'sans-serif'},{n:'Notable', t:'sans-serif'},{n:'Indie Flower', t:'cursive'},{n:'Shadows Into Light', t:'cursive'},{n:'Shadows Into Light Two', t:'cursive'},{n:'Amatic SC', t:'cursive'},{n:'Architects Daughter', t:'cursive'},{n:'Nothing You Could Do', t:'cursive'},{n:'Reenie Beanie', t:'cursive'},{n:'Sue Ellen Francisco', t:'cursive'},{n:'Squada One', t:'cursive'},{n:'Comfortaa', t:'cursive'},{n:'Quicksand', t:'sans-serif'},{n:'Shrikhand', t:'cursive'},{n:'Kaushan Script', t:'cursive'},{n:'Rock Salt', t:'cursive'},{n:'Barriecito', t:'cursive'},{n:'Mountains of Christmas', t:'cursive'},{n:'Righteous', t:'cursive'},{n:'Geostar', t:'cursive'},{n:'Patua One', t:'cursive'},{n:'Roboto Mono', t:'monospace'},{n:'Inconsolata', t:'monospace'},{n:'Source Code Pro', t:'monospace'},{n:'Cousine', t:'monospace'},{n:'PT Mono', t:'monospace'},{n:'Nanum Gothic Coding', t:'monospace'},{n:'Space Mono', t:'monospace'},{n:'Anonymous Pro', t:'monospace'},{n:'Cutive Mono', t:'monospace'},{n:'Oxygen Mono', t:'monospace'},{n:'Rancho', t:'cursive'},{n:'DM Sans', t:'sans-serif'},{n:'Arizonia', t:'cursive'},{n:'Rouge Script', t:'cursive'},{n:'Alex Brush', t:'cursive'},{n:'Sail', t:'cursive'},{n:'Sacramento', t:'cursive'},{n:'Marck Script', t:'cursive'},{n:'Sonsie One', t:'cursive'},{n:'Croissant One', t:'cursive'},{n:'Sofia', t:'cursive'},{n:'Noto Serif', t:'serif'},{n:'Arvo', t:'serif'}];

  function doFontFamily(font){
    return function(e){
      if (font === 'None (use default)'){
        clickFontFamily('');
      }else{
        setMostRecentFont(font);
        clickFontFamily(font);
      }
    }
  }

  // , 
  var fontPieces1 = fonts.filter((aFont, index)=>{
    return ((filterBit === 'noFilter') || (aFont.t === filterBit)) && (searchText === '' || aFont.n.toUpperCase().indexOf(searchText.toUpperCase()) > -1)
  }).sort(compare);

  fontPieces1.unshift({n:'None (use default)', t:''});

  var fontPieces = fontPieces1.map((aFont, index)=>{
    var className6 = 'fontSelector';
    if (currentFont === aFont.n){
      className6 = 'fontSelectorSelected';
    }
    return <div onClick={doFontFamily(aFont.n)} className={className6} onMouseDown={onMouseDown} style={{fontFamily:aFont.n}}>{aFont.n}</div>
  })
//
  var filterOptions = [{n:'No Filter', i:'noFilter'}, {n:'Monospace', i:'monospace'}, {n:'Cursive', i:'cursive'}, {n:'Serif', i:'serif'}, {n:'Sans Serif', i:'sans-serif'}];

  var selectedFont;
  if (currentFont){
    var coverTxt = 'Current Font';
    if (currentFont === mostRecentFont){
      coverTxt = 'Current & Most Recent Font';
    }
    selectedFont = <div style={{padding:'10px'}}><p className="lead mb-0" > <span style={{fontWeight:700}}>{coverTxt}</span> : <span style={{fontFamily:currentFont, cursor:'pointer', textDecoration:'underline'}} onClick={doFontFamily(currentFont)}>{currentFont}</span></p></div>
  }

  var mostRecentFontPiece;
  if (mostRecentFont && mostRecentFont !== currentFont){
    mostRecentFontPiece = <div style={{padding:'10px'}}><p className='lead mb-0 explanation' > <span style={{fontWeight:700}}>Most Recent Font</span> : <span style={{fontFamily:mostRecentFont, cursor:'pointer', textDecoration:'underline'}} onClick={doFontFamily(mostRecentFont)}>{mostRecentFont}</span></p></div>
  }

  return <div onMouseDown={onMouseDown}><center>
    {selectedFont}
    {mostRecentFontPiece}    
    <DropdownMenu isSortedAlphabetically={true}  clickItemInSelect={setFilterBit} options={filterOptions} currentAnswer={filterBit}/>
    {fontPieces}
    </center></div>
}


//
export default App;
